import type { Messages } from "@prop/i18n";
import type en from "../en/support";

export default {
  nav: "Помощь",
  title: "Помощь и поддержка",
  lead: "Сначала поищите ответ. Если его нет, напишите нам — ответ придёт сюда же.",
  search: "Поиск по ответам",
  searchPlaceholder: "например: дневной лимит, выплата, исполнение",
  noAnswers: "Ответов не нашлось. Попробуйте другие слова или напишите нам ниже.",
  notFound: "Не нашли ответ?",
  contact: "Написать в поддержку",
  categories: { account: "Аккаунт и правила", trading: "Торговля и исполнение", payments: "Платежи и выплаты", kyc: "Проверка личности", technical: "Техническая проблема", other: "Другое" },
  form: {
    title: "Новое обращение",
    category: "Тема",
    pickTopic: "Выберите тему",
    account: "Аккаунт (необязательно)",
    noAccount: "Не про конкретный аккаунт",
    subject: "Тема письма",
    subjectHint: "Одной строкой, например «Ордер исполнился по другой цене»",
    body: "Что случилось?",
    bodyHint: "Укажите время, инструмент и что вы ожидали. Одно обращение — одна проблема.",
    send: "Отправить",
    cancel: "Отмена",
  },
  my: "Мои обращения",
  none: "Обращений пока нет.",
  status: { open: "Ждёт поддержку", pending_staff: "Ждёт поддержку", pending_user: "Ждёт вашего ответа", resolved: "Решено", closed: "Закрыто" },
  thread: {
    back: "Все обращения",
    you: "Вы",
    support: "Поддержка",
    reply: "Ваш ответ",
    send: "Отправить",
    close: "Закрыть обращение",
    closed: "Обращение закрыто. Если нужна помощь, создайте новое.",
    resolvedHint: "Мы считаем, что вопрос решён. Если нет — ответьте, и обращение откроется снова.",
  },
  admin: {
    tab: "Поддержка",
    views: { queue: "Очередь", kb: "База ответов", templates: "Шаблоны" },
    filter: { active: "Ждут нас", waiting: "Ждут клиента", resolved: "Решённые", closed: "Закрытые", all: "Все" },
    anyCategory: "Любая тема",
    anyone: "Все",
    mine: "Мои",
    unassigned: "Без исполнителя",
    empty: "Здесь пусто. Очередь разобрана.",
    ticket: "Обращение",
    topic: "Тема",
    statusCol: "Статус",
    priorityCol: "Приоритет",
    due: "Первый ответ до",
    overdue: "просрочено",
    assignee: "Исполнитель",
    status: { open: "Новое", pending_staff: "Клиент ответил", pending_user: "Ждёт клиента", resolved: "Решено", closed: "Закрыто" },
    priority: { low: "Низкий", normal: "Обычный", high: "Высокий", urgent: "Срочный" },
    pick: "Выберите обращение в очереди.",
    account: "Аккаунт",
    language: "Язык",
    internal: "Внутренняя заметка",
    template: "Вставить шаблон",
    message: "Сообщение",
    noteMode: "Внутренняя заметка (клиент её не видит)",
    andResolve: "Отметить решённым",
    sendReply: "Отправить ответ",
    addNote: "Добавить заметку",
    kb: {
      new: "Новая статья",
      slug: "Slug (одинаковый для всех языков)",
      locale: "Язык",
      category: "Тема",
      title: "Заголовок",
      body: "Текст",
      sort: "Порядок",
      published: "Опубликована",
      draft: "Черновик",
      save: "Сохранить",
      delete: "Удалить",
      saved: "Сохранено.",
      confirmDelete: "Удалить насовсем?",
    },
    tpl: {
      new: "Новый шаблон",
      title: "Название",
      body: "Текст ({name} заменится на имя клиента)",
      category: "Тема",
      anyTopic: "Любая тема",
      locale: "Язык",
    },
  },
} satisfies Messages<typeof en>;
